export default __webpack_public_path__ + "static/media/correctIc.32e5b1e4.png";